import React from 'react'
import {Smartphone, BookOpen, Wheat, Pizza, Croissant, CakeSlice, Infinity as InfinityIcon, ShieldCheck} from 'lucide-react'

function ImmediateAccess() {
  const items = [
    { icon: Smartphone, text: 'Aplicativo exclusivo' },
    { icon: BookOpen, text: 'Mais de 400 receitas' },
    { icon: Wheat, text: 'Receitas de pães' },
    { icon: Pizza, text: 'Massas especiais' },
    { icon: Croissant, text: 'Croissants' },
    { icon: CakeSlice, text: 'Sobremesas' },
    { icon: InfinityIcon, text: 'Atualizações futuras' },
    { icon: ShieldCheck, text: 'Garantia de 7 dias' },
  ]

  return (
    <section className="bg-[#FCFAF5] py-20 md:py-28">
      <div className="max-w-[1200px] mx-auto px-6 md:px-10">
        <div className="text-center mb-14 animate-fade-up">
          <h2 className="font-display text-[#49352B] text-3xl md:text-5xl font-bold">
            O que você recebe imediatamente
          </h2>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {items.map((item, i) => {
            const Icon = item.icon
            return (
              <div
                key={i}
                className="bg-white rounded-[20px] p-6 border border-[#EBD9C3] shadow-sm hover:shadow-lg transition-all duration-300 hover:-translate-y-1 animate-fade-up flex flex-col items-center text-center gap-3"
              >
                <div className="w-12 h-12 rounded-full bg-[#EBD9C3] flex items-center justify-center">
                  <Icon className="w-6 h-6 text-[#D9891B]" />
                </div>
                <p className="text-[#49352B] font-semibold text-sm">{item.text}</p>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default ImmediateAccess
